import React from 'react';
import './App.css';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from '@BUP/hooks';
import {
  DataContextProvider,
  SociogramContextProvider,
  DashboardSociogramContextProvider,
  LoginLanguageContextProvider,
  ModeBupContextProvider,
} from '@BUP/contexts';
import BraveUp from './BraveUp';
import './configs/i18n';

const App = () => {
  return (
    <LoginLanguageContextProvider>
      <AuthProvider>
        <DataContextProvider>
          <ModeBupContextProvider>
            <SociogramContextProvider>
              <DashboardSociogramContextProvider>
                <BrowserRouter>
                  <BraveUp />
                </BrowserRouter>
              </DashboardSociogramContextProvider>
            </SociogramContextProvider>
          </ModeBupContextProvider>
        </DataContextProvider>
      </AuthProvider>
    </LoginLanguageContextProvider>
  );
};

export default App;
